/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Ladung(en)`
};

const en_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} recharge(s)`
};

const es_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} recarga(s)`
};

const fr_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} recharge(s)`
};

const it_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} ricarica/e`
};

const nl_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} laadbeurten`
};

const pt_route__recharge = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} recarga(s)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__recharge(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__recharge", locale)
	if (locale === "de") return de_route__recharge(inputs)
	if (locale === "en") return en_route__recharge(inputs)
	if (locale === "es") return es_route__recharge(inputs)
	if (locale === "fr") return fr_route__recharge(inputs)
	if (locale === "it") return it_route__recharge(inputs)
	if (locale === "nl") return nl_route__recharge(inputs)
	return pt_route__recharge(inputs)
};